/** Навигация, подвал, куки, 404 */
export const layoutRu: Record<string, string> = {
  "nav.logoAria": "IT-24.pro на главную",
  "nav.devops": "Услуги",
  "nav.admin": "Аудит",
  "nav.support": "Неотложная помощь",
  "nav.vps": "Контакты",
  "nav.k8s": "Проекты",
  "nav.cicd": "Кейсы",
  "nav.ddos": "Обо мне",
  "nav.llmops": "Retainer",
  "nav.packages": "Услуги",
  "nav.audience": "Для кого",
  "nav.cases": "Кейсы",
  "nav.portfolio": "Кейсы",
  "nav.contacts": "Контакты",
  "nav.auditCta": "Написать в Telegram",
  "nav.auditCtaShort": "Telegram",
  "nav.ariaMain": "Основная навигация",
  "nav.langSwitcherAria": "Язык сайта",
  "nav.menuOpen": "Открыть меню навигации",
  "nav.menuClose": "Закрыть меню навигации",
  "nav.langRu": "RU",
  "nav.langUk": "UA",
  "nav.langKk": "KZ",
  "nav.langUz": "UZ",
  "nav.langKy": "KG",

  "footer.tagline":
    "Инфраструктура для криптовалютного сектора, финтеха и highload. Юридическое лицо PL · Telegram.",
  "footer.badge1": "✓ PCI / DDoS / K8s",
  "footer.badge2": "✓ USDT / инвойс",
  "footer.badge3": "✓ С 2010 в инфраструктуре",
  "footer.consultCta": "Написать в Telegram",
  "footer.servicesTitle": "Услуги",
  "footer.tariffsHome": "Услуги на главной",
  "footer.devops": "DevOps retainer",
  "footer.serverSupport": "Неотложная помощь",
  "footer.serverAdmin": "Аудит",
  "footer.k8s": "Проекты PCI / DDoS / K8s",
  "footer.cicd": "Кейсы",
  "footer.ddos": "Обо мне",
  "footer.llmops": "Контакты",
  "footer.vps": "nexops.eu (EU)",
  "footer.vacancies": "Telegram",
  "footer.contactTitle": "Контакты",
  "footer.location": "Konin, Poland",
  "footer.copy": "Все права защищены.",
  "footer.taglineBottom": "Криптовалютный сектор · финтех · highload · Telegram",

  "cookie.title": "Мы используем куки для улучшения вашего опыта",
  "cookie.body":
    "Мы используем куки, чтобы помочь вам эффективно перемещаться по сайту и выполнять определенные функции. Продолжая использовать сайт, вы соглашаетесь с использованием куки.",
  "cookie.reject": "Отклонить",
  "cookie.accept": "Принять",

  "notFound.title": "Страница не найдена | IT-24.pro",
  "notFound.description":
    "Такой страницы нет. Инфраструктура для криптовалютного сектора и финтеха — на главной.",
  "notFound.h1": "Страница не найдена",
  "notFound.text":
    "Возможно, ссылка устарела — старые услуги перенесены на новые разделы.",
  "notFound.home": "На главную",
  "notFound.devops": "Retainer / услуги",

  "breadcrumb.home": "Главная",
  "breadcrumb.devopsServices": "Услуги",
  "breadcrumb.ariaLabel": "Навигационная цепочка",

  "search.title": "Поиск по сайту | IT-24.pro",
  "search.titleWithQuery": "Поиск: {query} | IT-24.pro",
  "search.description": "Поиск услуг: retainer, аудит, PCI, DDoS, Kubernetes на IT-24.pro.",
  "search.h1": "Поиск по сайту",
  "search.lead": "Найдите услугу: неотложная помощь, аудит, retainer, проекты.",
  "search.placeholder": "Например: pci, ddos, retainer",
  "search.submit": "Найти",
  "search.prompt": "Введите запрос — покажем подходящие разделы сайта.",
  "search.resultsCount": "Найдено: {count}",
  "search.noResults": "По запросу «{query}» ничего не найдено.",
  "search.emptyHint": "Попробуйте другие ключевые слова или перейдите к услугам.",
};
